exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n  Project Colors\n */\n:host {\n  display: block;\n  margin: 2em 1em;\n  width: 90%;\n  margin: 4em auto; }\n\n.snippet-title {\n  color: #9d9d9d;\n  background-color: #444;\n  margin: 0;\n  padding: 10px 8px;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/snippet/snippet.component.scss
// module id = 391
// module chunks = 1